import React from 'react';
import PropTypes from 'prop-types';
import {
    MultiList,
} from '@appbaseio/reactivesearch';

import Flex, { FlexChild } from '../styles/Flex';
import { searchFiltersContainer } from '../styles/Container';


const toCapitalFirstLetter = (phrase) => {
    return phrase
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

/**
 * The return values for boolean values are 0 and 1.
 * However the search operates only on false/true, that's why
 * we need to map this
 *
 * @param filterLines
 * @returns {*}
 */
const transformDerived = (filterLines) => {
    return filterLines.map(filterLine => ({...filterLine, key: filterLine.key !== 0}));
};

const transformEnabled = (filterLines) => {
    return filterLines.map(filterLine => ({...filterLine, key: filterLine.key !== 0}));
};

const renderEnabled = (label, count) => {
    label = label ? "Processed" : "Not processed";
    return renderListItem(label, count)
};

const renderDerived = (label, count) => {
    label = label ? "Derived" : "Model-native";
    return renderListItem(label, count)
};

const renderListItem = (label, count) => (
    <div className={"listItem"}>
        <div>{toCapitalFirstLetter(label)}</div>
        <div>{count}</div>
    </div>
);

const SearchFilters = ({ visible }) => (
    <Flex direction="column" hidden={!visible} className={searchFiltersContainer}>
        <FlexChild margin="10px" expectedItems={4}>
            <MultiList
                className={"multilist"}
                componentId="model"
                dataField="model.name.keyword"
                filterLabel="Model"
                innerClass={{
                    list: "list",
                }}
                placeholder="Select Model"
                queryFormat="or"
                react={{ and: ["levelType", "textSearch", "derived", "enabled"] }}
                renderListItem={renderListItem}
                showCheckbox={true}
                showCount={true}
                showFilter={true}
                showSearch={false}
                showMissing={true}
                sortBy={"asc"}
                title="Model"
                URLParams={true}
            />
        </FlexChild>
        <FlexChild margin="10px" expectedItems={6}>
            <MultiList
                className={"multilist"}
                componentId="levelType"
                dataField="levelType.keyword"
                filterLabel="Level-Type"
                innerClass={{
                    list: "list",
                }}
                queryFormat="or"
                react={{ and: ["model", "textSearch", "derived", "enabled"] }}
                renderListItem={renderListItem}
                showCheckbox={true}
                showCount={true}
                showFilter={true}
                showSearch={false}
                showMissing={true}
                sortBy={"asc"}
                title="Level"
                URLParams={true}
            />
        </FlexChild>
        <FlexChild margin="10px" expectedItems={2}>
            <MultiList
                className={"multilist"}
                componentId="derived"
                dataField="derived"
                filterLabel="Derived"
                innerClass={{
                    list: "list",
                }}
                placeholder="Derived"
                queryFormat={"or"}
                react={{ and: ["model", "textSearch", "levelType", "enabled"] }}
                renderListItem={renderDerived}
                showCheckbox={true}
                showCount={true}
                showFilter={true}
                showSearch={false}
                size={2}
                sortBy={"asc"}
                title={"Derived"}
                transformData={transformDerived}
                URLParams={true}
            />
        </FlexChild>
        <FlexChild margin="10px" expectedItems={2}>
            <MultiList
                className={"multilist"}
                componentId="enabled"
                dataField="enabled"
                filterLabel="Enabled"
                innerClass={{
                    list: "list",
                }}
                placeholder="Enabled"
                queryFormat={"or"}
                react={{ and: ["model", "textSearch", "levelType", "derived"] }}
                renderListItem={renderEnabled}
                showCheckbox={true}
                showCount={true}
                showFilter={true}
                showSearch={false}
                size={2}
                sortBy={"asc"}
                title={"Parameter"}
                transformData={transformEnabled}
                URLParams={true}
            />
        </FlexChild>
        <footer>
            Copyright © {new Date().getFullYear()} DTN, Inc.
        </footer>
    </Flex>
);

SearchFilters.propTypes = {
    visible: PropTypes.bool,
};

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/components/SearchFilters.js